import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WebhookTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const payload = {
      page: pathname,
      url: window.location.href,
      referrer: document.referrer || null,
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent,
    };

    fetch(`${BACKEND_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {});
  }, [pathname]);

  return null;
};

export default WebhookTracker;
